import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/_auth/procurement/supply-plan/$purchasePlanId/_layout/")({
  loader: async ({ params, parentMatchPromise }) => {
    if ((await parentMatchPromise).fullPath === "/procurement/supply-plan/$purchasePlanId") {
      throw redirect({
        to: "/procurement/supply-plan/$purchasePlanId/quantities",
        params,
      })
    }
    return null
  },
})
